import { ParamKeyValuePair } from 'react-router-dom';
import { DetailPageDto } from '@asset-metrix/portal-gateway-client-js';

import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { Filter } from '../../store/states/filterTypes';
import { DETAILS_PAGE_URL_DISCRIMINATOR_PARAM } from '../../utils/constants';
import { filtersToKeyValuePairs } from '../../utils/filtersToKeyValuePairs';
import { pageWithRoleLink } from '../../utils/urlPath';

export function getDetailPageUrl(
  roleId: string,
  detailPageConfig: DetailPageDto,
  pageFilter: Filter | undefined,
  dataRows: Record<string, unknown>[],
  label: string
): string {
  const href = pageWithRoleLink(roleId ?? NO_ROLE_ID, {
    slug: detailPageConfig.completeSlug,
    pageType: 'detailPage',
  });

  const detailsIdKey = detailPageConfig.detailsIdKey;
  // ensure page filters do not modify the configured details discriminator
  // the page we open the link from can have a pagefilter with the same key - exclude it
  let filterKeyValuePairs: ParamKeyValuePair[] = [];
  if (pageFilter != null) {
    const { [detailsIdKey]: _, ...rest } = pageFilter;
    filterKeyValuePairs = filtersToKeyValuePairs(rest);
  }

  // add configured detail page params
  filterKeyValuePairs.push([
    DETAILS_PAGE_URL_DISCRIMINATOR_PARAM,
    detailsIdKey,
  ]);

  for (const data of dataRows) {
    if (data?.[detailsIdKey] != null) {
      // add details filters & discriminator to params (identifies nav-item on deep-links)
      filterKeyValuePairs.push([detailsIdKey, String(data[detailsIdKey])]);
    }

    // add other columns configured as filters
    for (const key of detailPageConfig.additionalFilterColumnKeys) {
      // remove existing pagefilter entries if pagefilters and additionalFilterColumns share a key
      // the additionalFilterColumn beats the pagefilters in this case
      filterKeyValuePairs = filterKeyValuePairs.filter(([filterKey]) => {
        return filterKey !== key;
      });
      filterKeyValuePairs.push([key, String(data[key])]);
    }
  }

  filterKeyValuePairs = filterKeyValuePairs.filter(([filterKey]) => {
    return filterKey !== 'label';
  });
  filterKeyValuePairs.push(['label', label]);

  return `${href}?${new URLSearchParams(filterKeyValuePairs).toString()}`;
}
